import {
  get_profile_logo,
  normalize_organization_profile,
} from "@/utils/organization_profile";

const PLACEHOLDER_VALUES = ["community", "organisation", "your organisation"];

function present_real_text(value) {
  const text = String(value || "").trim();
  return Boolean(text && !PLACEHOLDER_VALUES.includes(text.toLowerCase()));
}

function first_real_text(...values) {
  return values.find(present_real_text) || "";
}

function has_logo(company = {}, details = {}) {
  return Boolean(get_profile_logo(company, details) || details?.organization_logo);
}

function get_address_from_location(location) {
  const parts = String(location || "")
    .split(",")
    .map(part => part.trim())
    .filter(Boolean);

  return {
    street_address: parts[0] || "",
    suburb: parts[1] || "",
    town: parts[2] || "",
    province: parts[3] || "",
    postal_code: parts[4] || "",
  };
}

export function get_organization_setup_items(company = {}, details = {}) {
  const organization = normalize_organization_profile(company || {}, details || {});
  const address = company?.address || {};
  const location_address = {
    ...get_address_from_location(organization.location),
    ...(company?.location_address || {}),
    ...(details?.location_address || {}),
  };

  return [
    { label: "Organisation name", done: present_real_text(organization.company_name) },
    { label: "Organisation type", done: present_real_text(organization.type_of_organization) },
    { label: "Logo", done: has_logo(company, details) },
    { label: "Description", done: present_real_text(organization.description) },
    { label: "Street address", done: present_real_text(first_real_text(company.street_address, details.street_address, address.street_address, location_address.street_address)) },
    { label: "Suburb / local area", done: present_real_text(first_real_text(company.suburb, company.local_area, details.suburb, address.suburb, location_address.suburb)) },
    { label: "Town / city", done: present_real_text(first_real_text(company.town, company.city, details.town, details.city, address.town, address.city, location_address.town, location_address.city)) },
    { label: "Province", done: present_real_text(first_real_text(company.province, details.province, address.province, location_address.province)) },
    { label: "Postal code", done: present_real_text(first_real_text(company.postal_code, company.code, details.postal_code, address.postal_code, location_address.postal_code)) },
    { label: "Email", done: present_real_text(organization.email) },
    { label: "Telephone", done: present_real_text(organization.tell_number) },
  ];
}

export function get_organization_setup_progress(company = {}, details = {}) {
  const items = get_organization_setup_items(company, details);
  const completed = items.filter(item => item.done).length;

  return {
    completed,
    total: items.length,
    percent: Math.round((completed / items.length) * 100),
    items,
  };
}
